import { ReactNode, useState } from 'react';
import styles from './WorkspaceShell.module.scss';
import WorkspaceHeader from './WorkspaceHeader';
import { Drawer, Button } from 'antd';
import { HistoryOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import NewChatButton from '../../components/NewButton/NewButton';

const NEED_HELP_URL =
  'https://eyukg.atlassian.net/jira/software/projects/RUBIX/form/68?atlOrigin=eyJpIjoiZjRiM2I0MWY4N2NlNDZjZjg1MDI3NmVmNzJiMmFjYjEiLCJwIjoiaiJ9';

interface Props {
  leftContent: ReactNode;
  mainContent: ReactNode;
  historyPanel: ReactNode;
  enableHistory?: boolean;
  showNewChatButton?: boolean;
  onNewChat?: () => void;
  onBrandClick?: () => void;
}

const WorkspaceShell = ({ leftContent, mainContent, historyPanel, enableHistory = true, showNewChatButton = false, onNewChat, onBrandClick }: Props) => {
  const [historyOpen, setHistoryOpen] = useState(false);
  return (
    <div className={styles.shell}>
      <WorkspaceHeader onBrandClick={onBrandClick} />
      <div className={styles.body}>
        <aside className={styles.left}>{leftContent}</aside>
        <main className={styles.main}>
          {enableHistory && (
            <div className="absolute top-16 right-4 z-10 flex gap-2">
              {showNewChatButton && onNewChat && (
                <NewChatButton
                  onClick={() => {
                    setHistoryOpen(false);
                    onNewChat();
                  }}
                />
              )}
              <Button icon={<HistoryOutlined />} onClick={() => setHistoryOpen(true)}>
                History
              </Button>
              <Button
                icon={<QuestionCircleOutlined />}
                href={NEED_HELP_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Need help
              </Button>
            </div>
          )}
          {mainContent}
        </main>
      </div>
      {enableHistory && (
        <Drawer title="Conversations" open={historyOpen} placement="right" width={320} onClose={() => setHistoryOpen(false)}>
          {historyPanel}
        </Drawer>
      )}
    </div>
  );
};
export default WorkspaceShell;
